import { configureStore } from '@reduxjs/toolkit'
import { miscReducer }    from './miscSlice'
import { filtersReducer } from './filtersSlice'
import { rosterApi }      from './rosterApi'

export const setupStore = (preloadedState) =>
  configureStore({
    reducer: {
      misc: miscReducer,
      filters: filtersReducer,
      [rosterApi.reducerPath]: rosterApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(rosterApi.middleware),
    preloadedState,
  })
